import { useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';

// Colors per theme — bg is the circle fill, accent is the highlight colour
const themeColors = {
  dark:       { bg: '#1E1E1E', accent: '#007bff',  screen: '#0d0d0d' },
  light:      { bg: '#dcdcdc', accent: '#0056b3',  screen: '#aaaaaa' },
  monochrome: { bg: '#e8e8e8', accent: '#444444',  screen: '#999999' },
  nord:       { bg: '#242933', accent: '#88C0D0',  screen: '#1a1f2a' },
  dracula:    { bg: '#21222C', accent: '#BD93F9',  screen: '#16171f' },
  forest:     { bg: '#0F1F0F', accent: '#4CAF50',  screen: '#071207' },
  slate:      { bg: '#020617', accent: '#38BDF8',  screen: '#010310' },
  gold:       { bg: '#0A0800', accent: '#C9A227',  screen: '#050400' },
  crimson:    { bg: '#0D0404', accent: '#E63946',  screen: '#060101' },
};

function buildFaviconSVG({ bg, accent, screen }) {
  // Laptop is designed in 300×300 space; we scale and centre it into a 200×200 circle.
  // transform: centre at (100,100), scale 0.72, then un-centre from laptop origin (150,185)
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
  <circle cx="100" cy="100" r="97" fill="${bg}"/>
  <g transform="translate(100,100) scale(0.72) translate(-150,-185)">
    <rect x="60" y="120" width="180" height="112" rx="9" fill="${accent}" fill-opacity="0.28"/>
    <rect x="72" y="130" width="156" height="90" rx="3" fill="${screen}"/>
    <rect x="72" y="130" width="156" height="90" rx="3" fill="${accent}" opacity="0.12"/>
    <rect x="84" y="143" width="52" height="3.5" rx="1.75" fill="${accent}" opacity="0.25"/>
    <rect x="84" y="154" width="72" height="3.5" rx="1.75" fill="#888" opacity="0.15"/>
    <rect x="84" y="165" width="44" height="3.5" rx="1.75" fill="${accent}" opacity="0.2"/>
    <rect x="84" y="178" width="128" height="1" rx="0.5" fill="#888" opacity="0.2"/>
    <text font-family="'Courier New',monospace" font-size="9" y="195">
      <tspan x="84" fill="#888" opacity="0.6">$ </tspan>
      <tspan fill="${accent}" opacity="0.9">Code</tspan>
    </text>
    <rect x="130" y="188" width="5.5" height="9" rx="1" fill="${accent}" opacity="0.9"/>
    <rect x="152" y="204" width="58" height="13" rx="6.5" fill="#22c55e" opacity="0.88"/>
    <text x="159" y="214" font-size="7.5" font-family="'Courier New',monospace" fill="#fff">&#x2713; Built!</text>
    <rect x="60" y="231" width="180" height="4" rx="2" fill="#888" opacity="0.25"/>
    <rect x="46" y="234" width="208" height="16" rx="8" fill="${accent}" fill-opacity="0.28"/>
    <rect x="124" y="238" width="52" height="8" rx="4" fill="#888" opacity="0.18"/>
  </g>
  <circle cx="100" cy="100" r="97" fill="none" stroke="${accent}" stroke-width="3"/>
</svg>`;
}

export default function FaviconSync() {
  const { theme } = useTheme();

  useEffect(() => {
    const colors = themeColors[theme] || themeColors.dark;
    const svg = buildFaviconSVG(colors);
    const href = 'data:image/svg+xml,' + encodeURIComponent(svg);

    // Update or create the SVG favicon link
    let link = document.querySelector('link[rel="icon"][type="image/svg+xml"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/svg+xml';
      document.head.appendChild(link);
    }
    link.href = href;
  }, [theme]);

  return null;
}
